import { getMessageFromRtkError } from "~/lib/rtkErrorToMessage";
import { OrderLine } from "~/redux/public/orders.openApi";
import { ErrorResponse } from "~/types/api";

export const normalizeLineItemWeightThresholds = (
  lineItem: OrderLine
): OrderLine => {
  const minimum =
    lineItem.fulfillmentRequirements?.weightThresholds?.error?.minimum?.value;
  const maximum =
    lineItem.fulfillmentRequirements?.weightThresholds?.error?.maximum?.value;

  if (minimum && maximum) {
    return {
      ...lineItem,
      fulfillmentRequirements: {
        weightThresholds: {
          error: {
            minimum: { unit: "lb", value: minimum },
            maximum: { unit: "lb", value: maximum }
          }
        }
      }
    };
  }

  const { fulfillmentRequirements: _, ...rest } = lineItem;
  return rest;
};

// custom client b and public endpoints have a non-standard error format
export const getErrorMessage = (error: unknown) => {
  const legacyError = error as {
    data?: ErrorResponse;
  };
  if (legacyError.data?.errorCode && legacyError.data?.message) {
    return `${legacyError.data.errorCode}: ${legacyError.data.message}`;
  }
  const publicApiError = error as {
    data?: { "error Info": string[] };
  };
  if (publicApiError.data?.["error Info"].length) {
    return publicApiError.data["error Info"].join(", ");
  }
  return getMessageFromRtkError(error);
};
